module.exports = __webpack_public_path__ + "static/nginx-e8f3c5678a67e98de33fb9dc58a1cd05.png";